module.exports = __webpack_public_path__ + "static/media/logo.8794d933.jpg";